import axios from 'axios'

const DraftService = {
  async get (params = {}) {
    return axios.get('wo/purchase-order/drafts', { params })
  },

  async show (id) {
    return axios.get(`wo/purchase-order/drafts/${id}`)
  },

  async post (params = {}) {
    return axios.post('wo/purchase-order/drafts', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`wo/purchase-order/drafts/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`wo/purchase-order/drafts/${data.id}`, { data })
  }
}

export default DraftService
